import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './ProjectInvitationAskQuestion.scss';
var ProjectInvitationAskQuestion = /*#__PURE__*/function (_Component) {
  function ProjectInvitationAskQuestion(props) {
    var _this;
    _classCallCheck(this, ProjectInvitationAskQuestion);
    _this = _callSuper(this, ProjectInvitationAskQuestion, [props]);
    _this.state = {
      message: '',
      submitted: false
    };
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ProjectInvitationAskQuestion, _Component);
  return _createClass(ProjectInvitationAskQuestion, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      this.setState({
        message: target.value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$props = this.props,
        formUrl = _this$props.formUrl,
        csrfToken = _this$props.csrfToken;
      var message = this.state.message;
      return putRequest(formUrl, {
        status: 'questioned',
        message: message
      }, csrfToken).then(function () {
        _this2.setState({
          submitted: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        message = _this$state.message,
        submitted = _this$state.submitted;
      return /*#__PURE__*/React.createElement(ModalTrigger, {
        triggerText: "Have a question?",
        buttonStyles: "secondary full-width",
        submitButtonText: "Send",
        handleSubmit: this.handleSubmit,
        submitDisabled: !message,
        cancelButton: false,
        idKey: "ask-question-on-project-invitation-modal",
        showFooter: !submitted
      }, submitted ? /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-8"
      }, "Your questions were sent!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-25"
      }, "Clora will follow up shortly via email with next steps.")) : /*#__PURE__*/React.createElement("div", {
        className: "style-guide"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "mb-8"
      }, "Questions"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3 "
      }, "Ask any questions you have about this project. Clora will triage your questions to the hiring manager."), /*#__PURE__*/React.createElement("textarea", {
        value: message,
        className: "form-control",
        placeholder: "Type here...",
        name: "message",
        id: "message",
        rows: "4",
        onChange: this.handleInputChange
      })));
    }
  }]);
}(Component);
ProjectInvitationAskQuestion.propTypes = {
  formUrl: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired
};
export default ProjectInvitationAskQuestion;